import ContentManager from './base';
import Panel from '../panels';

import { ViewNodeRenderer, TeacherPanelNodeRenderer } from '../../shared/reactLoader';

export default class ChecklistViewer extends ContentManager {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.type = context.type;
  }

  loadModal() {
    this.panel = new Panel(Panel.NODE, '', {
      modal_id: 'content-modal',
      name: this.context.getName(),
      fullscreen: this.options.fullscreen,
    });

    this.panel.updateContent('<div class="lp--panelLoader"></div>');

    this.attach();

    this.panel.eventSource.one('willHide.panel', () => {
      this.detach();
    });

    this.setupModal(this.panel);

    return Promise.resolve(this.panel);
  }

  attach() {
    if (this.options.viewer.teacherPanel) {
      TeacherPanelNodeRenderer.render(
        this.context.id,
        this.type,
        this.options,
        this.panel,
        this.options.viewer.student,
      );
      return;
    } else if (!this.options.viewer.teacherPanel) {
      ViewNodeRenderer.render(this.context.id, this.type, this.options, this.panel);
      return;
    }
  }

  load() {
    return Promise.resolve();
  }

  detach() {
    super.detach();
    this.panel.content.off('.task');
    this.panel.content.find('.comment').off('.comments');
    this.panel.content.find('.lp--js-nodeComment').off('.comments');
  }
}
